import React, { useEffect, useState } from "react";
import AppText from "../AppText";

import BackIcon from "../BackIcon";
import YellowButtonVideo from "../../../../assets/images/icons/Pulsante_play.svg";
import YellowButton from "../../../../assets/images/icons/Pulsante_giallo.svg";

// ----------------------------------------------------------------------------

export default function SlideImages(props) {
  const {
    image,
    onPlus,
    onMinus,
    style,
    pickPointsVideo,
    pickPoints,
    onClickPP,
    setSelectedVideo,
    noCenter,
    showArrows,
    marginLeft,
  } = props;

  const [height, setHeight] = useState(2000);
  const [width, setWidth] = useState(2000);

  function setDimensions(img) {
    setHeight(img?.target?.offsetHeight);
    setWidth(img?.target?.offsetWidth);
  }

  return (
    <div
      style={{
        height: height,
        width: width,

        position: "relative",
        margin: noCenter ? "" : "auto",
      }}
    >
      <img
        style={{
          position: "relative",
          objectPosition: "center",
          objectFit: "stretch",
          ...style,
        }}
        src={image}
        alt=""
        onLoad={(img) => setDimensions(img)}
      ></img>
      {pickPoints?.map((pp) => (
        <div
          style={{
            position: "absolute",
            left: `${pp.percentageX}%`,
            top: `${pp.percentageY}%`,
            zIndex: 100,
          }}
        >
          <div onClick={() => onClickPP(pp?.elementLinked)}>
            <img
              style={{ height: 50, width: 50, marginLeft: 45, marginTop: 20 }}
              src={YellowButton}
              alt=""
              className="animate-pulse"
            />
          </div>
        </div>
      ))}
      {pickPointsVideo?.map((pp) => (
        <div
          style={{
            position: "absolute",
            left: `${pp.percentageX}%`,
            top: `${pp.percentageY}%`,
            zIndex: 100,
          }}
        >
          <div onClick={() => setSelectedVideo(pp?.elementLinked)}>
            <img
              style={{ height: 50, width: 50 }}
              src={YellowButtonVideo}
              alt=""
              className="animate-pulse"
            />
          </div>
        </div>
      ))}
      {showArrows && (
        <div
          style={{
            alignSelf: "center",
            marginLeft: 5,
            zIndex: 1000,
            position: "absolute",
            top: "45%",
            left: marginLeft ? 30 : 0,
          }}
        >
          <BackIcon onClick={onMinus} background></BackIcon>
        </div>
      )}
      {showArrows && (
        <div
          style={{
            alignSelf: "center",

            zIndex: 1000,
            position: "absolute",
            top: "45%",
            left: width - (marginLeft ? 20 : 45),
          }}
        >
          <BackIcon onClick={onPlus} background rotate></BackIcon>
        </div>
      )}
    </div>
  );
}

// ----------------------------------------------------------------------------
